<p>user-logs-sessions works!</p>
